import { render, staticRenderFns } from "./LaborCost.vue?vue&type=template&id=2af49606&scoped=true"
import script from "./LaborCost.vue?vue&type=script&lang=js"
export * from "./LaborCost.vue?vue&type=script&lang=js"
import style0 from "./LaborCost.vue?vue&type=style&index=0&id=2af49606&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2af49606",
  null
  
)

export default component.exports